import Inventory from './Index.vue';

export const routes = [
  {
    path: 'estoque',
    name: 'talkvia_inventory',
    meta: {
      permissions: [
        'administrator',
        'agent',
        'custom_role',
        'inventory_manage',
      ],
    },
    component: Inventory,
  },
];
